export const environment = {
  youtubeApiKey: 'AIzaSyAyf2ejS73dbZF_VavsY5TEFydTIhzgM7w',
};
